import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const SUCCESS_TRACKING_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});
const RECORD = generateSchema(SUCCESS_TRACKING_SCHEMA);
const KEYS: any = generateKeys(SUCCESS_TRACKING_SCHEMA);

export class SuccessTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.success;
  }

  get properties() {
    return this.toJS();
  }
}
